import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [state, setState] = useState("loading"); // loading | ok | error
    const [msg, setMsg] = useState("");

    useEffect(() => {
        if (!token) { setState("error"); setMsg("This verification link is missing its token."); return; }
        api.post("/auth/verify-email", { token })
            .then(() => setState("ok"))
            .catch((err) => { setState("error"); setMsg(err?.response?.data?.detail || "This verification link is invalid or expired."); });
    }, [token]);

    return (
        <div className="max-w-md mx-auto px-6 py-20 text-center" data-testid="verify-page">
            {state === "loading" && (
                <div className="text-[#a0a0a0]"><Loader2 className="h-10 w-10 mx-auto animate-spin text-[#ff4500]" /><p className="mt-4 text-sm">Verifying your email…</p></div>
            )}
            {state === "ok" && (
                <div data-testid="verify-ok">
                    <CheckCircle2 className="h-14 w-14 mx-auto text-[#22c55e]" />
                    <h1 className="font-display text-4xl tracking-wide mt-4">Email verified</h1>
                    <p className="text-sm text-[#a0a0a0] mt-2">Thanks — your email address is confirmed.</p>
                    <Link to="/account" className="inline-block mt-6 bg-[#ff4500] hover:bg-[#ff5722] text-white px-6 h-11 leading-[44px] text-xs uppercase tracking-[0.2em] font-semibold">Go to my account</Link>
                </div>
            )}
            {state === "error" && (
                <div data-testid="verify-error">
                    <XCircle className="h-14 w-14 mx-auto text-[#ff4500]" />
                    <h1 className="font-display text-4xl tracking-wide mt-4">Verification failed</h1>
                    <p className="text-sm text-[#a0a0a0] mt-2">{msg}</p>
                    <Link to="/account" className="inline-block mt-6 text-xs uppercase tracking-[0.2em] text-[#ff4500] hover:underline">Go to my account to resend</Link>
                </div>
            )}
        </div>
    );
}
